export default "__VITE_ASSET__a3f59797__"